module.exports = __webpack_public_path__ + "static/media/BIFI-ETH.fa6f41d6.png";